module.exports = __webpack_public_path__ + "/Assets/icons/Mail-Grey.svg";